import { environment } from "../../../environments/environment";
import { SentryOutput } from "./sentry-output";

export class SentryObserve {
  /** Sentryで監視対象とするusernameを文字列指定。複数の場合は半角カンマで区切る。
   * Smile9StatusAPI(APIGateway)から取得した値を格納する。 */
  public static sentryObserveUsername: string = null;

  /** 出力対象のユーザーかどうか判定し、対象の場合のみログ出力する */
  public static checkAndOutputLog(logLevel: 'info' | 'error', exception: any = null) {
    try {
      if (this.sentryObserveUsername === null) {
        return;
      }
      const targets: string[] = this.sentryObserveUsername.split(',');
      const tokenUsername: string = localStorage.getItem(`CognitoIdentityServiceProvider.${environment.amplify.Auth.userPoolWebClientId}.LastAuthUser`);
      if (targets.length >= 1 && targets.some(username => username === tokenUsername)) {
        switch (logLevel) {
          case 'info':
            SentryOutput.sentryOutputLog();
            break;
          case 'error':
            SentryOutput.sentryOutputErrorLog(exception);
            break;
        }
      }
    }
    catch {
      // no action
    }
  }

  /** Smile9StatusAPIで指定されたusernameのユーザーのみ、定期的にSentryにログ出力させる。 */
  public static sentryObserveStart() {
    setInterval(() => {
      this.checkAndOutputLog('info');
    }, 10000);
  };
}
